import { memo } from 'react';
import { t } from 'i18next';
import { Stack } from '@mui/system';
import { Divider } from '@mui/material';

import { Accordion } from '@common/components/Accordion';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { ConstellationSpec } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/common/ConstellationSpec';
import StationaryType from '@/modules/salesWorkspace/components/propertyPanel/layout/components/stationary/StationaryType';
import { StationaryConnectNeighbors } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/stationary/StationaryConnectNeighbors';
import { VehicleType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/common/VehicleType';
import { Extensions } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/stationary/Extensions';
import { StationaryPoiPreferences } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/stationary/StationaryPoiPreferences';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { AreaDimensions } from './AreaDimensions';

function StationaryAreaParametersComponent() {
  const selectedAreas = useReadSelectedAreas();
  const selectedStationaryArea =
    selectedAreas.stationaryAreas.length === 1 ? selectedAreas.stationaryAreas[0] : null;

  if (!selectedStationaryArea) return null;

  return (
    <Stack spacing={1} divider={<Divider />}>
      <AreaDimensions />
      <Accordion
        title={t<string>('interface:properties.stationary_area.title', 'Stationary Area')}
        unmountOnExit
        defaultExpanded
        sx={{ px: 2 }}
      >
        <Stack direction='column' spacing={1}>
          <PropertiesLabel i18nkey='interface:properties.area.stationary_type'>
            <StationaryType />
          </PropertiesLabel>
          <PropertiesLabel i18nkey='interface:properties.area.connect_neighbors'>
            <StationaryConnectNeighbors />
          </PropertiesLabel>
          <Extensions />
          <Accordion title='Constellation settings' unmountOnExit defaultExpanded>
            <Stack direction='column' spacing={1}>
              <ConstellationSpec />
            </Stack>
          </Accordion>
          <Accordion title='Vehicle settings' unmountOnExit defaultExpanded>
            <Stack direction='column' spacing={1}>
              <StationaryPoiPreferences selectedStationaryArea={selectedStationaryArea} />
              <VehicleType />
            </Stack>
          </Accordion>
        </Stack>
      </Accordion>
    </Stack>
  );
}

export const StationaryAreaParameters = memo(StationaryAreaParametersComponent);
